var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDfwMavericks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 327,
    viewBox: "0 0 327 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 313.907L3 13.1556C3 7.64251 7.4975 2.99993 13.1556 2.99993C184.786 2.99993 324.063 142.277 324.063 313.907C324.063 319.42 319.565 324.062 313.907 324.062H13.1556C7.64258 324.062 3 319.565 3 313.907Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 315.938L3 78.0064H18.5236C145.759 78.0064 249.056 181.304 249.056 308.539V324.062H11.1245C6.62703 324.062 3 320.435 3 315.938Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 318.84L3 166.07C3 163.169 5.32126 160.992 8.07779 160.992C95.271 160.992 166.07 231.791 166.07 318.985C166.07 321.886 163.749 324.062 160.992 324.062H8.2229C5.32129 324.062 3.14511 321.741 3.14511 318.985L3 318.84Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M323.918 316.811V10.4015C323.918 6.39519 320.67 3.14746 316.664 3.14746L10.2545 3.14746C6.24823 3.14746 3.00052 6.39519 3.00052 10.4015V316.811C3.00052 320.817 6.24823 324.065 10.2545 324.065H316.664C320.67 324.065 323.918 320.817 323.918 316.811Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfwMavericks);
export default __webpack_public_path__ + "static/media/dfw-Mavericks.2f4982b04393683ac68d4138c1f5da79.svg";
export { ForwardRef as ReactComponent };